
export class HttpResponse
{
    public status;
    public data;
}
